module.exports = __webpack_public_path__ + "ce829663b4e2d76327d89d87ce21b6a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/global-nav/mazda-logo-compact.svg
// module id = 1258
// module chunks = 0 1